import { render, staticRenderFns } from "./editSocialAccount.vue?vue&type=template&id=46d4c6c4&lang=pug"
import script from "./editSocialAccount.vue?vue&type=script&lang=js"
export * from "./editSocialAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports